import React, { useEffect, useContext } from "react"
import { navigate } from "gatsby"
import { Locale } from "../context/Locale"

const getRedirectLanguage = () => {
  if (typeof navigator === `undefined`) {
    return "en"
  }

  const lang = navigator?.language?.split("-")[0]
  if (!lang) return "en"

  return lang === "fr" ? "fr" : "en"
}

const Index = () => {
  const { setLocale } = useContext(Locale)
  const fallbackLang = getRedirectLanguage()
  const isFrench = fallbackLang === "fr"

  useEffect(() => {
    setLocale(fallbackLang)
    navigate(`/${fallbackLang}`, { replace: true })
  }, [fallbackLang, setLocale])

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        background: "#f7f5f0",
        color: "#111",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div style={{ maxWidth: "32rem", textAlign: "center" }}>
        <p
          style={{
            margin: 0,
            fontSize: "0.75rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            opacity: 0.65,
          }}
        >
          GADAIT International
        </p>
        <h1
          style={{
            margin: "1rem 0 0.75rem",
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            lineHeight: 1.05,
            fontFamily: "Georgia, serif",
            fontWeight: 400,
          }}
        >
          {isFrench
            ? "Redirection vers votre langue pr\u00e9f\u00e9r\u00e9e"
            : "Redirecting to your preferred language"}
        </h1>
        <p
          style={{ margin: "0 auto 1.5rem", maxWidth: "28rem", lineHeight: 1.6 }}
        >
          {isFrench
            ? "Si rien ne se passe, choisissez votre version."
            : "If nothing happens, choose your version."}
        </p>
        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <a
            href="/en"
            style={{
              padding: "0.9rem 1.4rem",
              borderRadius: "999px",
              background: "#111",
              color: "#fff",
              textDecoration: "none",
            }}
          >
            English
          </a>
          <a
            href="/fr"
            style={{
              padding: "0.9rem 1.4rem",
              borderRadius: "999px",
              border: "1px solid rgba(17,17,17,0.2)",
              color: "#111",
              textDecoration: "none",
              background: "rgba(255,255,255,0.7)",
            }}
          >
            Fran&ccedil;ais
          </a>
        </div>
      </div>
    </main>
  )
}

export default Index
